export default __webpack_public_path__ + "static/media/loader.5dc2d012.gif";